
import { APIS } from '../../../_config';
import { CallApi } from '../callApi';

export interface SubAppellationFormData {
  name: string;
  appellation_id: number;
  country_id: number | null;
  region_id: number | null;
  sub_region_id: number | null;
}

export interface SubAppellation {
  id: number;
  name: string;
  appellation_id: number;
  country_id: number | null;
  region_id: number | null;
  sub_region_id: number | null;
  appellation?: any;
  country?: any;
  region?: any;
  subregion?: any;
  date_created: string;
  last_updated: string;
}

export function useSubAppellationApi() {
  // List subappellations
  const getSubAppellationList = async (params: any = {}): Promise<any> => {
    const response = await CallApi.GET(
      APIS.LOCATION_SETTINGS.SUB_APPELLATION.SUB_APPELLATIONS,
      params,
      true
    );
    return response;
  };

  // Get single subappellation by ID
  const getSubAppellationById = async (id: number): Promise<any> => {
    const response = await CallApi.GET(
      APIS.LOCATION_SETTINGS.SUB_APPELLATION.DETAIL(String(id)),
      {},
      true
    );
    return response;
  };

  // Create subappellation
  const createSubAppellation = async (data: SubAppellationFormData): Promise<any> => {
    const response = await CallApi.POST(
      APIS.LOCATION_SETTINGS.SUB_APPELLATION.SUB_APPELLATIONS,
      data,
      true
    );
    return response;
  };

  // Update subappellation
  const updateSubAppellation = async (id: number, data: SubAppellationFormData): Promise<any> => {
    const response = await CallApi.PUT(
      APIS.LOCATION_SETTINGS.SUB_APPELLATION.DETAIL(String(id)),
      data,
      true
    );
    return response;
  };

  // Delete subappellation
  const deleteSubAppellation = async (id: number): Promise<any> => {
    const response = await CallApi.DELETE(
      APIS.LOCATION_SETTINGS.SUB_APPELLATION.DETAIL(String(id)),
      true
    );
    return response;
  };

  return {
    getSubAppellationList,
    getSubAppellationById,
    createSubAppellation,
    updateSubAppellation,
    deleteSubAppellation,
  };
}
